export const EMAIL_FIELD_NAME = 'email';
export const NEWSLETTER_TERMS_NAME = 'termsConditions';
export const FORM_TEST_ID = 'form-test-id';
